import React from 'react';
import { StyledDropdown as CheggUiDropdown } from '../Shared/styled';
import { SOURCE_TITLE_LABEL, SOURCE_TITLE_TEST_ID, DESCRIPTION_LABEL, DESCRIPTION_TEST_ID, UNIQUE_KEY_FOR_DATE_FIELD, DATE_CREATED_LABEL, DATE_CREATED_TEST_ID, SourceTypeOptions, SOURCE_TYPE_LABEL, SOURCE_TYPE_TEST_ID, SOURCE_TYPE_HELPER_TEXT } from '../../forms/miscellaneous/constants';
import { Input, Section } from '../Shared';
import { PubDate } from '../Shared/PubDate';
import { CITING_SECTION_TITLE } from './constants';
import { SourceType, PubMainTypeEnum, PubSuffixTypeEnum } from '../../types';

/** Miscellaneous citing section id and testId */
export var SECTION_ID = 'miscellaneous-citing-section';
export var SECTION_TEST_ID = 'miscellaneous-citing-section-test-id';
export var MiscellaneousCitingSection = function MiscellaneousCitingSection(_ref) {
  var onSourceChange = _ref.onSourceChange;
  var getPubTypeMain = function getPubTypeMain(source) {
    switch (source) {
      case SourceType.WEBSITE:
        return PubMainTypeEnum.PUB_ONLINE;
      case SourceType.DIGITAL_FILE:
        return PubMainTypeEnum.PUB_OTHER;
      default:
        return PubMainTypeEnum.PUB_OTHER;
    }
  };
  var handleSourceChange = function handleSourceChange(_ref2) {
    var value = _ref2.value;
    if (onSourceChange) {
      onSourceChange(value, {
        main: getPubTypeMain(value),
        suffix: PubSuffixTypeEnum.PUB_NONE
      });
    }
  };
  return /*#__PURE__*/React.createElement(Section, {
    sectionId: SECTION_ID,
    title: CITING_SECTION_TITLE,
    ariaLabelledby: "".concat(SECTION_ID, "-label"),
    dataTestId: SECTION_TEST_ID
  }, /*#__PURE__*/React.createElement(CheggUiDropdown, {
    inputId: "source",
    options: SourceTypeOptions,
    value: SourceTypeOptions[0].value,
    labelText: SOURCE_TYPE_LABEL,
    "data-test": SOURCE_TYPE_TEST_ID,
    helperText: SOURCE_TYPE_HELPER_TEXT,
    onSelectValue: function onSelectValue(selectedOption) {
      return handleSourceChange({
        value: selectedOption
      });
    }
  }), /*#__PURE__*/React.createElement(Input, {
    type: "text",
    name: "miscellaneous.title",
    labelText: SOURCE_TITLE_LABEL,
    "data-test": SOURCE_TITLE_TEST_ID
  }), /*#__PURE__*/React.createElement(Input, {
    type: "text",
    name: "miscellaneous.desc",
    labelText: DESCRIPTION_LABEL,
    "data-test": DESCRIPTION_TEST_ID
  }), /*#__PURE__*/React.createElement(PubDate, {
    key: UNIQUE_KEY_FOR_DATE_FIELD,
    labelText: DATE_CREATED_LABEL,
    "data-test": DATE_CREATED_TEST_ID,
    formikFieldNames: ['miscellaneous.day', 'miscellaneous.month', 'miscellaneous.year'],
    isRecommended: false
  }));
};